import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { CampaignComplianceReview } from '../../extViewmodels/sdk/models/Telephony';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { invalidateTelephonyGetConfiguration } from './useTelephonyConfigurationQuery';

export function useTelephonyComplianceReviewRunMutation({
	onError,
	onSuccess,
}: {
	onError?: (error: Api.IOperationResultNoValue) => void;
	onSuccess?: (review: CampaignComplianceReview) => void;
} = {}) {
	const userSession = useUserSession();
	return useMutation({
		// The endpoint is impersonation-only: it exists solely on the admin controller under
		// impersonate/{accountId}/admin/telephony/...
		mutationFn: (params: { impersonationContext?: Api.IImpersonationContext }) => {
			return userSession.webServiceHelper.callAsync<CampaignComplianceReview>(
				Api.ImpersonationBroker.composeApiUrl({
					urlPath: 'admin/telephony/config/complianceReview/run',
					impersonationContext: params.impersonationContext,
				}),
				'POST'
			);
		},
		onError,
		onSuccess: review => {
			// The run is persisted server-side, so the cached configuration is stale
			invalidateTelephonyGetConfiguration();
			onSuccess?.(review);
		},
	});
}
